import { type IAdvancedRichText } from './IAdvancedRichText.ts';

/**
 * Controlla se è presente un testo IAdvancedRichText. (hasTextAdvanced)
 */
export function hasRichTextAdvanced(
  text: IAdvancedRichText | undefined | null,
): boolean {
  if (!text) return false;

  if (text.length > 1 || (text[0].text && text[0].text?.length > 0)) {
    return true;
  }
  return false;
}
